export class RCSSuggestionStats {
  suggestionID: number;
  displayText: string;
  suggestionType: string;
  suggestionScope: string;
  cardIndex: number;
  clickCount: number;
  sentCount: number;
  totalClicks: number;
}
